module.exports = __webpack_public_path__ + "static/img/manager-icon.ee94c85c.png";